var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from 'class-transformer';
import { IsDateString, IsEnum, IsOptional, IsString, IsUUID } from 'class-validator';
import { Role } from '../../roles/index.js';
/**
 * Response DTO for FileUpload queries.
 * This DTO is independent of the domain entity and is optimized for the view layer.
 */
export class FileUploadResponseDto {
    id;
    createdAt;
    createdBy;
    createdByRole;
    updatedAt;
    originalFilename;
    filename;
    patientId;
    officeId;
    /**
     * Staff only: the day of the documentation entry the file is attached to (see
     * `FileUploadFullSizeDto.documentationDate`); null for a file uploaded on its own.
     */
    documentationDate;
}
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], FileUploadResponseDto.prototype, "id", void 0);
__decorate([
    IsDateString(),
    Expose(),
    __metadata("design:type", Date)
], FileUploadResponseDto.prototype, "createdAt", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], FileUploadResponseDto.prototype, "createdBy", void 0);
__decorate([
    IsEnum(Role),
    IsOptional(),
    Expose(),
    __metadata("design:type", String)
], FileUploadResponseDto.prototype, "createdByRole", void 0);
__decorate([
    IsDateString(),
    Expose(),
    __metadata("design:type", Date)
], FileUploadResponseDto.prototype, "updatedAt", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], FileUploadResponseDto.prototype, "originalFilename", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], FileUploadResponseDto.prototype, "filename", void 0);
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], FileUploadResponseDto.prototype, "patientId", void 0);
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], FileUploadResponseDto.prototype, "officeId", void 0);
__decorate([
    IsDateString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], FileUploadResponseDto.prototype, "documentationDate", void 0);
//# sourceMappingURL=file-upload.response.dto.js.map